export const blockIconsAndroidNetworkCheckNew = (
	<span className='material-symbols-outlined'>network_check</span>
);
